import React, { useEffect, useState } from "react";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { BRAND } from "@/constants/brand";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Why Infolocus", href: "#why" },
  { label: "Process", href: "#process" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#FAFAFA]/85 backdrop-blur-xl border-b border-[#E2E8F0]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex items-center justify-between h-20">
          <a
            href="#top"
            data-testid="header-logo-link"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="flex items-center gap-3"
          >
            <img
              src={BRAND.logoUrl}
              alt="Infolocus"
              className="h-9 w-auto object-contain"
              data-testid="header-logo-image"
            />
            <span className="sr-only">Infolocus</span>
          </a>

          <nav className="hidden md:flex items-center gap-9">
            {NAV.map((item) => (
              <button
                key={item.href}
                onClick={() => handleNav(item.href)}
                data-testid={`nav-${item.href.replace("#", "")}`}
                className="text-sm font-medium text-[#475569] hover:text-[#1B2A6E] transition-colors"
              >
                {item.label}
              </button>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <button
              onClick={() => handleNav("#contact")}
              data-testid="header-cta-button"
              className="group inline-flex items-center gap-2 bg-[#1B2A6E] text-white hover:bg-[#152259] px-5 py-2.5 rounded-sm text-sm font-semibold transition-colors"
            >
              Talk to us
              <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
          </div>

          <button
            className="md:hidden p-2 text-[#1B2A6E]"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {open && (
          <div className="md:hidden pb-6 border-t border-[#E2E8F0] pt-4" data-testid="mobile-menu-panel">
            <div className="flex flex-col gap-4">
              {NAV.map((item) => (
                <button
                  key={item.href}
                  onClick={() => handleNav(item.href)}
                  data-testid={`mobile-nav-${item.href.replace("#", "")}`}
                  className="text-left text-base font-medium text-[#0B1120]"
                >
                  {item.label}
                </button>
              ))}
              <button
                onClick={() => handleNav("#contact")}
                data-testid="mobile-header-cta-button"
                className="mt-2 inline-flex items-center justify-center gap-2 bg-[#1B2A6E] text-white px-5 py-3 rounded-sm text-sm font-semibold"
              >
                Talk to us
                <ArrowUpRight className="h-4 w-4" />
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};
